module.exports = __webpack_public_path__ + "img/cartel.375c2c6f.gif";